import ConfigProvider from 'antd/es/config-provider/index';
import { ComponentProps } from 'react';

export const AntConfigProvider = ConfigProvider;
export type AntConfigProviderProps = ComponentProps<typeof AntConfigProvider>;
